import React, { FC } from 'react';
import { Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';

import { ContentFilterProps } from 'hoc/withFilter';
import { StyledFilterFormSearch } from 'pages/Wim/Grid/styles';
import { DumpFilterFormValues } from '../../types';

export const FilterPanel: FC<ContentFilterProps<DumpFilterFormValues>> = ({ filterManager }) => {
  const { t } = useTranslation();
  const { handleFilterChange, state, onFilterSubmitClick } = filterManager;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleFilterChange('search', event.currentTarget.value);
  };

  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onFilterSubmitClick();
    }
  };

  return (
    <Row>
      <Col span={12}>
        <StyledFilterFormSearch
          id="search"
          name="search"
          placeholder={t('common.search')}
          onChange={onChange}
          value={state.search}
          onKeyDown={onKeyDown}
          allowClear
        />
      </Col>
    </Row>
  );
};
